'use client';

export { default } from './SvgIcon';
export * from './SvgIconProps';
export { default as svgIconClasses } from './svgIconClasses';
export * from './svgIconClasses';